import { queryClient } from "react-query/queryClient";
import { usersUrls } from "./Urls";
import axiosInstance, { lock } from "utils/axiosInstance";
import {detectPathUrl} from "./detectPathUrl";

const getLocalStorageToken = () => localStorage.getItem('token');

const logoutHandler = () => {
    if (localStorage.getItem('fireBaseToken')) {
        axiosInstance.delete(usersUrls.deleteNotificationToken(localStorage.getItem('fireBaseToken')));
    }
    lock.disable();
    queryClient.clear();
    queryClient.removeQueries();
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(detectPathUrl('authentication/login'));
    window?.ReactNativeWebView?.postMessage('logout');
};


export { getLocalStorageToken, logoutHandler };